<template>
    <div class="div-next">
        <span>Next Steps & Ongoing Efforts</span>
        <div class="main-next">
            We are coordinating with security researchers and regulatory agencies to ensure compliance with data protection laws.
            A detailed post-mortem report will be published within 72 hours, outlining:
            <br />
            <br />
            1. Root cause analysis and timeline of events
            <br />
            2. Long-term security measures to prevent recurrence
            <br />
            3. Transparency report on data exposure and mitigations
            <br />
            <br />
            For further inquiries, please contact <span>security@privacybee.com</span>
        </div>
    </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.div-next {
  @apply flex flex-col items-start gap-2;
  
  span {
    @apply text-zinc-700 font-inter text-base font-semibold leading-6;
  }
}

.main-next {
  @apply text-zinc-950 font-inter text-sm font-normal leading-6;
  
  span {
    @apply text-blue-600 font-inter text-sm font-semibold leading-6;
  }
}
</style>
